module.exports = __webpack_public_path__ + "static/media/journey.f61b3b40.png";